import { isBoolean } from 'lodash';

import { PreInterview } from '@dreryk/egabinet-pre-interview-frontend-api';

import { Badge, BadgePosition, BadgeType } from '@dreryk/react-components';

type PreInterviewBadgeProps = {
   readonly preInterview: PreInterview | undefined | null;
   readonly children: JSX.Element;
};

export const PreInterviewBadge = (props: PreInterviewBadgeProps): JSX.Element => {
   return (
      <Badge
         type={BadgeType.WARNING}
         position={BadgePosition.TOP_RIGHT}
         testId={'readingStatus'}
         visible={isBoolean(props.preInterview?.read) ? !props.preInterview?.read : false}
         compact
      >
         {props.children}
      </Badge>
   );
};
